import { LessonOrder } from "@repo/app-types/entities/jobType";
import {
  PermissionActions,
  PermissionSubjects,
} from "@repo/app-types/entities/teammatePermissions";
import { Size } from "@repo/ui/helpers/helpers";
import { Label } from "@repo/ui/Label/label";
import { SimpleRadioGroup } from "@repo/ui/Radio/simpleRadioGroup";
import { SimpleRadioOption } from "@repo/ui/Radio/simpleRadioOption";
import type { FC } from "react";
import { Can } from "../../../../helpers/teammateAuthorizationContext.js";

interface LessonOrderSettingProps {
  lessonOrder: LessonOrder;
  onSave: (lessonOrder: LessonOrder) => void;
}

export const LessonOrderSetting: FC<LessonOrderSettingProps> = ({
  lessonOrder,
  onSave,
}) => {
  return (
    <Can
      I={PermissionActions.UPDATE}
      a={PermissionSubjects.JOB_OPENINGS}
      passThrough={true}
    >
      {(allowed) => (
        <div className="space-y-2">
          <Label size={Size.SMALL} className="block">
            Lesson order
          </Label>
          <SimpleRadioGroup
            value={lessonOrder}
            onChange={(value) => {
              onSave(value as LessonOrder);
            }}
          >
            <SimpleRadioOption
              value={LessonOrder.Sequential}
              isDisabled={!allowed}
            >
              Each lesson must be completed before the next one becomes
              available
            </SimpleRadioOption>
            <SimpleRadioOption value={LessonOrder.Any} isDisabled={!allowed}>
              Lessons can be completed in any order
            </SimpleRadioOption>
          </SimpleRadioGroup>
        </div>
      )}
    </Can>
  );
};
